import {
  ArcRotateCamera,
  ArcRotateCameraPointersInput,
  Vector3,
} from '@babylonjs/core';

import assert from '../assert.js';
import { getState } from '../state.js';
import type { Ref, State } from '../types.js';
import {
  CustomCameraKeyboardMoveInput,
  CustomCameraMouseWheelInput,
} from './inputs.js';

const createCamera = (stateRef: Ref<State>) => (): void => {
  const state = getState(stateRef);

  const { scene, emptyScene } = state;

  assert(scene);
  assert(emptyScene);

  const camera = new ArcRotateCamera(
    'myCamera',
    0,
    0,
    0,
    Vector3.Zero(),
    scene,
  );

  camera.useInputToRestoreState = false;

  const { inputs } = camera;

  inputs.clear();

  const keyboardMoveInput = new CustomCameraKeyboardMoveInput();

  keyboardMoveInput.keysLeft = [39];
  keyboardMoveInput.keysRight = [37];
  keyboardMoveInput.keysUp = [40];
  keyboardMoveInput.keysDown = [38];
  keyboardMoveInput.keysReset = [32];

  inputs.add(keyboardMoveInput);

  const pointersInput = new ArcRotateCameraPointersInput();

  inputs.add(pointersInput);

  const mouseWheelInput = new CustomCameraMouseWheelInput();

  inputs.add(mouseWheelInput);

  // Disables panning.
  camera.panningSensibility = 0;

  emptyScene.activeCamera = camera;
};

export default createCamera;
